import { RouteType } from '@/lib/route';
import QuizComponent from '.';

const QuizRoutes: RouteType = {
  path: '/module/:elearningId/quiz',
  component: QuizComponent,
};

export default QuizRoutes;
